import React, { useState, useEffect, useContext } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import api, { BASE_URL } from "../../Utils/api";
import { GlobalContext } from "../../Utils/GlobalContext";


const TiposFornecedorModal = ({ show, handleClose, fornecedor, fetchTiposFornecedor }) => {
  const [descricao, setDescricao] = useState("");
  const [situacao, setSituacao] = useState("A");
  const [error, setError] = useState(null);

  const { globalData } = useContext(GlobalContext);
  const entidadeID = globalData?.entidade_id || localStorage.getItem("entidade_id");

  useEffect(() => {
    if (!show) return;
    setError(null);
    if (fornecedor) {
      setDescricao(fornecedor.descricao || "");
      setSituacao(fornecedor.situacao || "A");
    } else {
      setDescricao("");
      setSituacao("A");
    }
  }, [show, fornecedor]);

  const handleSave = async () => {
    setError(null);
    const descricaoTrim = (descricao || "").trim();
    if (!descricaoTrim) {
      setError("Descrição é obrigatória.");
      return;
    }
    const fornecedorData = { descricao: descricaoTrim, situacao };

    try {
      let resultado = null;
      if (fornecedor) {
        await api.put(
          `${BASE_URL}/api/tiposEmpresa/EditarTiposEmpresa/${fornecedor.id}`,
          fornecedorData
        );
      } else {
        const res = await api.post(
          `${BASE_URL}/api/tiposEmpresa/InserirTiposEmpresa/${entidadeID}`,
          fornecedorData
        );
        resultado = res.data?.data || res.data || null;
      }

      fetchTiposFornecedor();
      handleClose(resultado);
    } catch (err) {
      console.error("Erro ao salvar tipo de fornecedor:", err);
      setError(err.response?.data?.message || "Erro ao salvar. Tente novamente.");
    }
  };

  return (
    <Modal show={show} onHide={handleClose} backdrop="static" dialogClassName="modal-dialog-top">
      <Modal.Header closeButton style={{ background: "var(--surface-sunken)", borderColor: "var(--border-default)", paddingBottom: 12 }}>
        <Modal.Title style={{ fontSize: "1rem", fontWeight: 600, color: "var(--text-body)" }}>
          {fornecedor ? "Editar Tipo de Fornecedor" : "Novo Tipo de Fornecedor"}
          {fornecedor?.descricao && (
            <span style={{ display: "block", fontSize: "0.82rem", fontWeight: 400, color: "var(--text-muted)", marginTop: 2 }}>
              {fornecedor.descricao}
            </span>
          )}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ background: "var(--surface-card)", color: "var(--text-body)" }}>
        {error && (
          <div className="alert alert-danger" role="alert">
            {error}
          </div>
        )}
        <Form>
          <Form.Group controlId="formDescricao">
            <Form.Label>Descrição <span className="text-danger">*</span></Form.Label>
            <Form.Control
              type="text"
              placeholder="Informe a descrição"
              value={descricao}
              onChange={(e) => setDescricao(e.target.value)}
              required
            />
          </Form.Group>

          <Form.Group controlId="formSituacao" className="mt-3">
            <Form.Label>Situação</Form.Label>
            <Form.Select
              value={situacao}
              onChange={(e) => setSituacao(e.target.value)}
            >
              <option value="A">Ativo</option>
              <option value="I">Inativo</option>
            </Form.Select>
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer className="modal-footer-padrao">
        <div className="modal-footer-acoes-esquerda" />
        <div className="modal-footer-acoes-direita">
          <Button variant="light" className="modal-footer-btn-cancelar" onClick={handleClose}>
            Cancelar
          </Button>
          <Button variant="success" className="modal-footer-btn-salvar" onClick={handleSave}>
            Salvar
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default TiposFornecedorModal;
